import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { map, tap, take } from 'rxjs/operators';
import { DataProvider } from './base.data-provider';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, of } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class FirebaseDataProvider extends DataProvider {
  private headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(private afDB: AngularFireDatabase, private db: AngularFirestore, private http: HttpClient) {
    super();
  }

  getAlergenos(): Promise<any[]> {
    return this.loadAlergenos('alergenos');
  }

  setUserId(id: string) {
    const path = 'users/' + id;
    const u = {
      msg: new Date()
    };
    this.afDB
      .object(path)
      .update(u)
      .catch(error => console.log(error));
  }

  // saveOrder(cart, userData, tipoPedido) {
  //   const path = 'pedidos/' + getUniqueId(4);
  //   const u = {
  //     preparado: false,
  //     cobrado: false,
  //     tipo: tipoPedido,
  //     fecha: new Date(),
  //     pedido: cart,
  //     cliente: userData
  //   };
  //   this.afDB
  //     .object(path)
  //     .update(u)
  //     .catch(error => console.log(error));
  // }
  saveOrder(cart, userData, tipoPedido, fechaSolicitada) {
    const path = 'pedidos';
    // + getUniqueId(4);
    const u = {
      preparado: false,
      cobrado: false,
      enCurso: false,
      tipo: tipoPedido,
      fecha: Date.now(),
      fechaSolicitada,
      pedido: cart,
      cliente: userData
    };
    return this.db
      .collection(path)
      .add(u)
      .catch(error => console.log('Error: ', error));
  }

  crearAvisoEmail(cuerpoCorreo: any, destinatario: string, asunto: string, parametroCorreo: string): Observable<any> {
    const mensaje = {
      email: destinatario,
      content: cuerpoCorreo,
      subject: asunto,
      from: parametroCorreo
    };
    return this.http.post('https://dedoclicback.herokuapp.com/correo', mensaje, { headers: this.headers });
    // return of(true);
    // return this.http.post('http://localhost:8080/correo', mensaje, { headers: this.headers });
  }

  getGenericsGrupos(): Promise<any[]> {
    return this.loadItems('generics').then(generics => {
      return generics.filter(x => x.mostrar && x.grupo && x.boton);
    });
  }

  getGenerics(): Promise<any[]> {
    return this.loadItems('generics').then(generics => {
      return generics.filter(x => x.mostrar && !x.otros);
    });
  }

  getGenericsOthers(): Promise<any[]> {
    return this.loadItems('generics').then(generics => {
      return generics.filter(x => x.mostrar && x.otros);
    });
  }

  getArticles(): Promise<any[]> {
    return this.loadItems('news');
  }

  getArticle(guid: string): Promise<any[]> {
    return this.getArticles().then(articles => {
      return articles.find(article => article.guid === guid);
    });
  }

  getBusiness(): Promise<any> {
    return this.afDB
      .object<any>('local')
      .snapshotChanges()
      .pipe(
        map(action => ({ $key: action.key, ...action.payload.val() })),
        tap(item => this.initItem(item)),
        take(1)
      )
      .toPromise();
  }

  getCategories(): Promise<any[]> {
    return this.loadItems('grupos').then(items => {
      items.forEach((x: any) => (x.icon = 'restaurant'));
      return items;
    });
  }

  getCategory(guid: string): Promise<any[]> {
    return this.getCategories().then(categories => {
      return categories.find(category => category.guid === guid);
    });
  }

  getFeaturedCategories(): Promise<any[]> {
    return this.getCategories().then(items => {
      return items.filter(x => x.featured && x.desayuno === false && x.vino === false);
    });
  }

  async getGruposByGenerics(genericsGuid): Promise<any[]> {
    return this.loadItems('grupos').then(items => items.filter((x: any) => x.generics === genericsGuid && x.activo));
  }

  getFeaturedProduct(productId: string): Promise<any> {
    return this.getFeaturedProducts().then(items => items.find(x => x.$key === productId));
  }

  getFeaturedProducts(): Promise<any[]> {
    return this.loadItems('platos').then(items => {
      return items.filter((x: any) => x.isFeatured);
    });
  }

  getAllProducts(): Promise<any[]> {
    return this.loadItems('platos').then(items => {
      return items.filter((x: any) => x.activo);
    });
  }

  getProduct(categoryId: string, productId: string): Promise<any> {
    return this.loadItems('platos').then(items => items.find((x: any) => x.guid === productId));
  }

  getProducts(categoryGuid): Promise<any[]> {
    return this.loadItems('platos').then(items => items.filter((x: any) => x.category === categoryGuid && x.activo));
  }

  private loadItems(type: string) {
    return this.afDB
      .list(type)
      .snapshotChanges()
      .pipe(
        map(actions => actions.map((action: any) => ({ $key: action.key, ...action.payload.val() }))),
        tap(items => this.initArray(items)),
        take(1)
      )
      .toPromise();
  }

  private loadAlergenos(type: string) {
    return this.afDB
      .list(type)
      .snapshotChanges()
      .pipe(
        map(actions => actions.map((action: any) => ({ activo: false, ...action.payload.val() }))),
        tap(items => this.initArray(items)),
        take(1)
      )
      .toPromise();
  }

  private getPobs(type: string) {
    return this.afDB
      .list(type)
      .snapshotChanges()
      .pipe(
        map(actions => actions.map((action: any) => ({ ...action.payload.val() }))),
        tap(items => this.initArray(items)),
        take(1)
      )
      .toPromise();
  }

  getPoblaciones(): Promise<any[]> {
    return this.getPobs('poblaciones');
  }

  private initItem(item) {
    item.guid = item.$key;
  }

  private initArray(array) {
    return array.map(x => this.initItem(x));
  }
}
